/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSurveyAnswerDto
 */
export interface CreateUpdateSurveyAnswerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyAnswerDto
     */
    questionId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSurveyAnswerDto
     */
    booleanValue?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyAnswerDto
     */
    textValue?: string;
}

/**
 * Check if a given object implements the CreateUpdateSurveyAnswerDto interface.
 */
export function instanceOfCreateUpdateSurveyAnswerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "questionId" in value;

    return isInstance;
}

export function CreateUpdateSurveyAnswerDtoFromJSON(json: any): CreateUpdateSurveyAnswerDto {
    return CreateUpdateSurveyAnswerDtoFromJSONTyped(json, false);
}

export function CreateUpdateSurveyAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSurveyAnswerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'booleanValue': !exists(json, 'booleanValue') ? undefined : json['booleanValue'],
        'textValue': !exists(json, 'textValue') ? undefined : json['textValue'],
    };
}

export function CreateUpdateSurveyAnswerDtoToJSON(value?: CreateUpdateSurveyAnswerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'questionId': value.questionId,
        'booleanValue': value.booleanValue,
        'textValue': value.textValue,
    };
}

